
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { Store, } from '~/apps/move-in/store';
import ProgressSteps from '~/components/move-in/move-in-progress-steps.vue';
import Spinner from '~/components/spinner/spinner.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';

@Component({
	components: {
		Alert: () => import('~/components/alert/alert.vue'),
		ProgressSteps,
		Spinner,
		UnauthedNav,
	},
	metaInfo: {
		title: 'Move in - Southern Water',
		meta: [
			{
				name: 'description',
				content: `If you're a new customer, just moved to the Southern Water region or responsible for the bill, you can set up an account with us using our online services.`,
			},
		] ,
	},
})
export default class MoveInApp extends Vue {
	get currentStep() {
		return Store.state.currentStep;
	}

	get showSpinner() {
		return Store.state.showSpinner;
	}

	get activeAlert() {
		return Store.state.alertModule.activeAlert;
	}

	// get isMoveInForcefullySucceeded() {
	// 	return Store.state.userDetails.isMoveInForcefullySucceeded;
	// }

	get progressStepsPhase() {
		return Store.state.progressStepsPhase;
	}

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	phase1Steps: string[] = [
		'Moving details',
		'Your details',
		'Payment details',
	];

	phase2Steps: string[] = [
		'Moving details',
		'Your details',
		'Payment details',
		'Bank details',
		'Check details',
	];

	phase3Steps: string[] = [
		'Login details',
		'Verify email',
	];

	progressStepsLabels = this.phase1Steps;

	@Watch('progressStepsPhase')
	upDateProgressSteps() {
		this.handleProgressSteps(this.progressStepsPhase);
	}

	handleProgressSteps(param: string) {
		if (param === 'phase1Steps') {
			this.progressStepsLabels = this.phase1Steps;
		} else if (param === 'phase2Steps') {
			this.progressStepsLabels = this.phase2Steps;
		} else if (param === 'phase3Steps') {
			this.progressStepsLabels = this.phase3Steps;
		}
	}

	closeAlert() {
		Store.commit.dismissActiveAlert();
	}

	@Watch('$route')
	onRouteChange() {
		this.$nextTick(() => {
			const focusTarget = document.querySelector('header') as HTMLElement;
			focusTarget.setAttribute('tabindex', '-1');
			focusTarget.focus();
			focusTarget.removeAttribute('tabindex');
		});
	}
}
